module.exports = __webpack_public_path__ + "img/thumb_35.34276a09.jpg";